import React from 'react';
import styles from './BelongingsPrintRow.module.scss';

interface BelongingsPrintRowProps {
    item: {
        petName: string;
        petBreed: string;
        belongings: string;
        roomName: string;
        unitName: string;
        notes: string;
    };
}

export const BelongingsPrintRow: React.FC<BelongingsPrintRowProps> = ({ item }) => {
    return (
        <tr className={styles.row}>
            <td className={styles.colPet}>
                <span className={styles.petName}>{item.petName}</span>
                <span className={styles.petBelongings}>{item.belongings}</span>
            </td>
            <td className={styles.colRoom}>
                {item.roomName} · {item.unitName}
            </td>
            <td className={styles.colNotes}>{item.notes || <span className={styles.empty}>–</span>}</td>
        </tr>
    );
};

export default BelongingsPrintRow;
